import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiMenu, FiX } from "react-icons/fi";

const navItems = [
  { label: "Home", id: "home" },
  { label: "Programs", id: "programs" },
  { label: "Reviews", id: "reviews" },
  { label: "Contact", id: "contact" },
];

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handleScroll = (sectionId) => {
    setMenuOpen(false);
    if (window.location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        document.getElementById(sectionId)?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }, 80);
    } else {
      document.getElementById(sectionId)?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-white/10 bg-slate-950/60 backdrop-blur-2xl shadow-2xl shadow-slate-950/20">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 md:px-8">
        <div className="flex items-center gap-3">
          <div className="rounded-3xl bg-slate-900/90 px-3 py-2 text-base font-semibold uppercase tracking-[0.24em] text-emerald-300 shadow-lg shadow-emerald-500/10">
            KG
          </div>
          <div className="text-sm font-semibold uppercase tracking-[0.18em] text-slate-200">
            Shuttle Court
          </div>
        </div>

        <nav className="hidden items-center gap-8 md:flex">
          {navItems.map((item) => (
            <button
              type="button"
              key={item.id}
              onClick={() => handleScroll(item.id)}
              className="text-sm font-medium text-slate-200 transition duration-200 hover:text-emerald-300 hover:tracking-[0.24em]"
            >
              {item.label}
            </button>
          ))}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          <a
            href="tel:+919840777003"
            className="rounded-full bg-emerald-500 px-5 py-2 text-sm font-semibold text-slate-950 transition duration-200 hover:bg-emerald-400"
          >
            Book Court
          </a>
        </div>

        <button
          type="button"
          className="inline-flex items-center justify-center rounded-full border border-white/10 bg-slate-900/90 p-2 text-slate-100 md:hidden"
          onClick={() => setMenuOpen((prev) => !prev)}
          aria-label="Toggle navigation menu"
        >
          {menuOpen ? <FiX size={22} /> : <FiMenu size={22} />}
        </button>
      </div>

      {menuOpen && (
        <div className="border-t border-white/10 bg-slate-950/95 px-6 py-5 md:hidden">
          <div className="flex flex-col gap-4">
            {navItems.map((item) => (
              <button
                type="button"
                key={item.id}
                onClick={() => handleScroll(item.id)}
                className="w-full rounded-2xl px-4 py-3 text-left text-base font-medium text-slate-100 transition hover:bg-slate-900/80 hover:text-emerald-300"
              >
                {item.label}
              </button>
            ))}
            <a
              href="tel:+919840777003"
              onClick={() => setMenuOpen(false)}
              className="w-full rounded-2xl bg-emerald-500 px-4 py-3 text-center text-sm font-semibold text-slate-950 transition hover:bg-emerald-400"
            >
              Book Court
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
